require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./progressindicator"), require("./listdropdown"), require("./searchinput"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./progressindicator", "./listdropdown", "./searchinput"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./progressindicator"), require("./listdropdown"), require("./searchinput")) : factory(root["./utils"], root["./progressindicator"], root["./listdropdown"], root["./searchinput"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__27__, __WEBPACK_EXTERNAL_MODULE__36__, __WEBPACK_EXTERNAL_MODULE__57__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[2],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(140);


/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _AutoCompleteInput = _interopRequireDefault(__webpack_require__(141));

exports["default"] = _AutoCompleteInput["default"];
exports.AutoCompleteInput = _AutoCompleteInput["default"];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _reactDom = __webpack_require__(14);

var _utils = __webpack_require__(4);

var _searchinput = _interopRequireDefault(__webpack_require__(57));

var _progressindicator = _interopRequireDefault(__webpack_require__(27));

var _listdropdown = _interopRequireDefault(__webpack_require__(36));

var _AutoCompleteInput = _interopRequireDefault(__webpack_require__(142));

var _StringResource = _interopRequireDefault(__webpack_require__(144));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var startsWithFilter = _utils.arrayFilters.startsWithFilter,
    containsFilter = _utils.arrayFilters.containsFilter;

var autoCompleteInputClassName = _AutoCompleteInput["default"].autoCompleteInputClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;
var getKeyName = _utils.keyboardUtils.getKeyName,
    keyNames = _utils.keyboardUtils.keyNames;
var get = _utils.lodash.get,
    uniqueId = _utils.lodash.uniqueId,
    isEqual = _utils.lodash.isEqual;

var AutoCompleteInput = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(AutoCompleteInput, _Component);

  function AutoCompleteInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSubmit", function (v) {
      var value;
      var currentStringValue = _this.state.value;

      if (v) {
        value = v;
      } else if (_this._arrayContainsObj(_this.props.values)) {
        value = {
          value: currentStringValue,
          label: currentStringValue
        };
      } else {
        value = currentStringValue;
      }

      _this.props.onSubmit && _this.props.onSubmit(value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onSelectionChange", function (index, submit) {
      if (index >= 0) {
        var filteredValues = _this.state.filteredValues;
        var value = filteredValues[index];

        _this.setState({
          open: false,
          focusIndex: -1,
          value: _this._getStringValue(value)
        }); // expose string or object in callbacks


        _this.props.onSelectionChange && _this.props.onSelectionChange(value);
        submit && _this._onSubmit(value);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSelectionChange", function (val, name, index) {
      _this._onSelectionChange(index, true);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onActiveChange", function (index) {
      _this.setState({
        focusIndex: index,
        value: _this._getStringValue(_this.state.filteredValues[index])
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      var focusIndex = _this.state.focusIndex;
      var filteredValues = _this.state.filteredValues;
      var SHIFT = keyNames.SHIFT,
          ESCAPE = keyNames.ESCAPE,
          A = keyNames.A,
          HOME = keyNames.HOME,
          UP = keyNames.UP,
          DOWN = keyNames.DOWN,
          ENTER = keyNames.ENTER,
          SPACE = keyNames.SPACE;

      if (_this.state.open) {
        switch (getKeyName(e)) {
          case SHIFT:
            break;

          case HOME:
            e.preventDefault();

            if (filteredValues && filteredValues.length) {
              var newFocusIndex = 0;

              _this.setState({
                focusIndex: newFocusIndex,
                value: _this._getStringValue(filteredValues[newFocusIndex])
              });
            }

            break;

          case UP:
            e.preventDefault();

            if (filteredValues && filteredValues.length) {
              if (focusIndex === 0) {
                _this.setState({
                  focusIndex: -1,
                  value: _this._getStringValue(_this.props.value)
                });
              } else if (focusIndex === -1) {
                var _newFocusIndex = filteredValues.length - 1;

                _this.setState({
                  focusIndex: _newFocusIndex,
                  value: _this._getStringValue(filteredValues[_newFocusIndex])
                });
              } else {
                _this._handleKeyEventByList(e);
              }
            }

            break;

          case DOWN:
            e.preventDefault();

            if (filteredValues && filteredValues.length) {
              if (focusIndex === filteredValues.length - 1) {
                _this.setState({
                  focusIndex: -1,
                  value: _this._getStringValue(_this.props.value)
                });
              } else if (focusIndex === -1) {
                _this.setState({
                  focusIndex: 0,
                  value: _this._getStringValue(filteredValues[0])
                });
              } else {
                _this._handleKeyEventByList(e);
              }
            }

            break;

          case ESCAPE:
            e.preventDefault();

            _this.setState({
              open: false,
              focusIndex: -1,
              value: ''
            });

            break;

          case SPACE:
            if (focusIndex !== -1) {
              _this._onSelectionChange(focusIndex);
            }

            break;

          case A:
            // override key event handler for e.ctrlKey || e.metaKey in List.js
            break;

          case ENTER:
            if (focusIndex === -1) {
              _this._onSubmit();

              _this.setState({
                open: false
              });

              break;
            }

          // falls through

          default:
            _this._handleKeyEventByList(e);

        }
      } else {
        switch (getKeyName(e)) {
          case ENTER:
            _this._onSubmit();

            break;

          case ESCAPE:
            e.preventDefault();

            _this.setState({
              focusIndex: -1,
              value: ''
            });

            break;

          case UP: // falls through

          case DOWN:
            // arrow down
            e.preventDefault();

            _this.setState({
              open: true
            });

            break;

          case SPACE:
            if (e.ctrlKey) {
              e.preventDefault();

              _this.setState({
                open: true
              });
            }

            break;

          default:
        }
      }

      _this.props.onKeyDown && _this.props.onKeyDown(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (value) {
      var values = _this.props.values;

      _this._notifyChange(value);

      var hasFilteredValues = _this._hasFilteredValues(value, values);

      _this.setState({
        open: hasFilteredValues,
        value: _this._getStringValue(value)
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      // Defect 229379: Prevent dropdown from closing when user clicks on scroll arrow buttons
      var listNode = get((0, _assertThisInitialized2["default"])(_this), '_dropdown._list._node');

      if (listNode && (listNode.contains(document.activeElement) || listNode.contains(e.relatedTarget)) || e.target !== e.currentTarget) {
        _this.focus();

        return;
      }

      if (_this.state.open) {
        _this.setState({
          open: false
        });
      }

      _this.props.onBlur && _this.props.onBlur(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_triggerNodeRenderer", function (_ref) {
      var _this$props = _this.props,
          id = _this$props.id,
          dataTid = _this$props['data-tid'],
          fullWidth = _this$props.fullWidth,
          iconLeft = _this$props.iconLeft,
          hideLeftIcon = _this$props.hideLeftIcon,
          ariaLabel = _this$props.ariaLabel,
          ariaLabelledBy = _this$props.ariaLabelledBy,
          loading = _this$props.loading,
          progressIndicatorExtraOptions = _this$props.progressIndicatorExtraOptions,
          others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["id", "data-tid", "fullWidth", "iconLeft", "hideLeftIcon", "ariaLabel", "ariaLabelledBy", "loading", "progressIndicatorExtraOptions"]);
      var autocompleteIcon = loading && !hideLeftIcon ? /*#__PURE__*/_react["default"].createElement(_progressindicator["default"], (0, _extends2["default"])({
        "data-tid": "ba-auto-complete__progress-indicator"
      }, sanitize(progressIndicatorExtraOptions, AutoCompleteInput), {
        variant: "circle",
        tabIndex: -1,
        size: "small"
      })) : iconLeft;
      var value = _this.state.value;
      var searchInputPassthroughProps = getInheritedProps(others, _searchinput["default"]);
      return /*#__PURE__*/_react["default"].createElement(_searchinput["default"], (0, _extends2["default"])({
        "aria-label": ariaLabel,
        ariaLabelledBy: ariaLabelledBy // pass this to BaseInput
        ,
        "aria-controls": _this._id,
        "aria-expanded": _this.state.open,
        "data-tid": "ba-auto-complete__search-input"
      }, searchInputPassthroughProps, {
        fullWidth: true,
        iconLeft: autocompleteIcon,
        hideLeftIcon: hideLeftIcon,
        onChange: _this._onChange,
        onBlur: _this._onBlur,
        value: value,
        ref: function ref(node) {
          _this._input = node;
          if (node) _ref((0, _reactDom.findDOMNode)(node));
        },
        onKeyDown: _this._onKeyDown
      }));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_parseFilteredValues", function (values) {
      var objArr = values.map(function (obj) {
        if (typeof obj === 'string') {
          return {
            label: obj,
            value: obj
          };
        } else if (!obj.value && obj.label) {
          obj.value = obj.label;
        }

        return obj;
      });
      return objArr;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_dropdownRef", function (node) {
      _this._dropdown = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClose", function () {
      _this.setState({
        open: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onScrollClose", function () {
      _this.setState({
        open: false
      });
    });
    _this.state = {
      focusIndex: -1,
      filteredValues: _this._filterValues(props),
      value: _this._getStringValue(props.value),
      open: false
    };
    _this.textDir = props.textDir;
    _this._id = uniqueId('__autocompleteinput_');
    return _this;
  }

  var _proto = AutoCompleteInput.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var values = nextProps.values;

    var value = this._getStringValue(nextProps.value);

    if (value !== '') {
      // Defect 244355: Check when new props values is passed in and open dropdown if there are any matched values.
      var openState = !isEqual(values, this.props.values) ? {
        open: this._hasFilteredValues(value, values)
      } : {}; // Defect 249963: Update value state only when value props changed

      var newValue = value !== this._getStringValue(this.props.value) ? value : this.state.value;

      if (this.state.focusIndex !== -1) {
        this.setState((0, _extends2["default"])({
          focusIndex: -1,
          value: newValue,
          filteredValues: this._filterValues(nextProps)
        }, openState));
      } else if (this.state.focusIndex === -1) {
        this.setState((0, _extends2["default"])({
          value: newValue,
          filteredValues: this._filterValues(nextProps)
        }, openState));
      }
    } else {
      // reset filtered value list when text input is empty
      // Defect 239844: add value in set state to clear input field whenever empty string is passed to prop.value
      this.setState({
        filteredValues: this._filterValues(nextProps),
        value: value
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.focusIndex !== prevState.focusIndex && this._list) {
      this._list.scrollAround(this.state.focusIndex);
    }
  };

  _proto.focus = function focus() {
    this._input && this._input.focus();
  };

  _proto._filterValues = function _filterValues(_ref2) {
    var _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? '' : _ref2$value,
        _ref2$values = _ref2.values,
        values = _ref2$values === void 0 ? [] : _ref2$values;
    var customFilter = this.props.customFilter;

    var stringValue = this._getStringValue(value);

    if (stringValue === null) {
      stringValue = '';
    }

    if (customFilter) {
      // Story 252514: Add custom filter for server side auto-completion
      return customFilter({
        value: stringValue.trim(),
        values: values
      });
    } else if (values && values.filter) {
      stringValue = stringValue.trim();
      var filterFn = stringValue.length === 1 && this.props.filterFromStart ? startsWithFilter(stringValue) : containsFilter(stringValue);
      return values.filter(filterFn);
    }

    return [];
  };

  _proto._getStringValue = function _getStringValue(value) {
    if (typeof value !== 'string' && value !== null) {
      return value.label;
    }

    return value;
  };

  _proto._arrayContainsObj = function _arrayContainsObj(arr) {
    for (var i = 0; i < arr.length; i++) {
      if (typeof arr[i] === 'object') {
        return true;
      }
    }

    return false;
  };

  _proto._notifyChange = function _notifyChange(value) {
    this.props.onChange && this.props.onChange(value);
  };

  _proto._hasFilteredValues = function _hasFilteredValues(value, values) {
    var filteredValues = this._filterValues({
      value: value,
      values: values
    });

    if (value.trim().length && filteredValues.length) {
      this.props.onValueMatch && this.props.onValueMatch(filteredValues);
      return true;
    }

    return false;
  };

  _proto._handleKeyEventByList = function _handleKeyEventByList(e) {
    var list = get(this, '_dropdown._list');
    list && list.handleKeyEvent(e);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        id = _this$props2.id,
        dataTid = _this$props2['data-tid'],
        fullWidth = _this$props2.fullWidth,
        iconLeft = _this$props2.iconLeft,
        hideLeftIcon = _this$props2.hideLeftIcon,
        className = _this$props2.className,
        style = _this$props2.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["id", "data-tid", "fullWidth", "iconLeft", "hideLeftIcon", "className", "style"]);
    var _this$state = this.state,
        filteredValues = _this$state.filteredValues,
        focusIndex = _this$state.focusIndex,
        open = _this$state.open;
    var classNames = (0, _utils.classnames)(autoCompleteInputClassName, {
      fullWidth: fullWidth
    });
    var dropdownProps = (0, _extends2["default"])({
      triggerNodeId: this._id,
      id: id,
      'data-tid': dataTid || 'ba-auto-complete__search-input'
    }, sanitize(others, AutoCompleteInput), {
      triggerNodeRenderer: this._triggerNodeRenderer,
      options: this._parseFilteredValues(filteredValues),
      open: open,
      className: classNames + " " + className,
      ref: this._dropdownRef,
      focusIndex: focusIndex,
      onClose: this._onClose,
      onActiveChange: this._onActiveChange,
      onChange: this.onSelectionChange,
      onScrollClose: this._onScrollClose,
      truncated: true,
      style: style
    });
    return /*#__PURE__*/_react["default"].createElement(_listdropdown["default"], dropdownProps);
  };

  return AutoCompleteInput;
}(_react.Component);

exports["default"] = AutoCompleteInput;
(0, _defineProperty2["default"])(AutoCompleteInput, "propTypes", (0, _extends2["default"])({}, _searchinput["default"].propTypes, {
  values: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].arrayOf(_propTypes["default"].object)]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  loading: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onValueMatch: _propTypes["default"].func,
  onSelectionChange: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  collapseExtraOptions: _propTypes["default"].object,
  listExtraOptions: _propTypes["default"].object,
  progressIndicatorExtraOptions: _propTypes["default"].object,
  filterFromStart: _propTypes["default"].bool,
  ariaLabel: _propTypes["default"].string,
  ariaLabelledBy: _propTypes["default"].string,
  customFilter: _propTypes["default"].func
}));
(0, _defineProperty2["default"])(AutoCompleteInput, "defaultProps", (0, _extends2["default"])({}, _searchinput["default"].defaultProps, {
  filterFromStart: true,
  value: '',
  values: [],
  collapseExtraOptions: {},
  listExtraOptions: {},
  progressIndicatorExtraOptions: {},
  ariaLabel: _StringResource["default"].get('autoCompleteSearchInput'),
  ariaLabelledBy: ''
}));

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(143);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-autoCompleteInput{position:relative;display:inline-block}.ba-common-autoCompleteInput.is-fullWidth{display:block}.ba-common-autoCompleteInput.is-fullWidth .ba-common-searchInput{width:100%}\n", ""]);

// exports
exports.locals = {
	"autoCompleteInputClassName": "\"ba-common-autoCompleteInput\""
};

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _AutoCompleteInputResources = _interopRequireDefault(__webpack_require__(145));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_AutoCompleteInputResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

var amdi18n={"__root":{"autoCompleteSearchInput":"auto complete search input"},"__cs":{"autoCompleteSearchInput":"vstup vyhledávání s automatickým dokončováním"},"__da":{"autoCompleteSearchInput":"automatisk fuldførelse af søgeinput"},"__de":{"autoCompleteSearchInput":"Sucheingabe automatisch vervollständigen"},"__es":{"autoCompleteSearchInput":"autocompletar entrada de búsqueda"},"__fi":{"autoCompleteSearchInput":"Automaattinen hakusyöttö"},"__fr":{"autoCompleteSearchInput":"entrée pour la recherche par saisie semi-automatique"},"__hr":{"autoCompleteSearchInput":"automatska dopuna ulaza za pretraživanje"},"__hu":{"autoCompleteSearchInput":"keresési bevitel automatikus kiegészítése"},"__it":{"autoCompleteSearchInput":"completa automaticamente l'input per la ricerca"},"__ja":{"autoCompleteSearchInput":"オートコンプリート検索入力"},"__kk":{"autoCompleteSearchInput":"авто аяқтау іздеуін енгізу"},"__ko":{"autoCompleteSearchInput":"자동 완성 검색 입력"},"__nb":{"autoCompleteSearchInput":"søketekst med automatisk utfylling"},"__nl":{"autoCompleteSearchInput":"invoer voor zoeken automatisch voltooien"},"__no":{"autoCompleteSearchInput":"søketekst med automatisk utfylling"},"__pl":{"autoCompleteSearchInput":"automatyczne uzupełnianie danych wejściowych wyszukiwania"},"__pt":{"autoCompleteSearchInput":"entrada de procura de preenchimento automático"},"__pt-br":{"autoCompleteSearchInput":"entrada de procura de preenchimento automático"},"__ro":{"autoCompleteSearchInput":"completare automată intrare de căutare"},"__ru":{"autoCompleteSearchInput":"автозаполнение ввода поиска"},"__sl":{"autoCompleteSearchInput":"samodejno dokončanje iskalnega vnosa"},"__sv":{"autoCompleteSearchInput":"indata automatisk sökning"},"__th":{"autoCompleteSearchInput":"อินพุตการค้นหาแบบสมบูรณ์โดยอัตโนมัติ"},"__tr":{"autoCompleteSearchInput":"Arama girişini otomatik tamamla"},"__zh":{"autoCompleteSearchInput":"自动完成搜索输入"},"__zh-cn":{"autoCompleteSearchInput":"自动完成搜索输入"},"__zh-hk":{"autoCompleteSearchInput":"自動完成搜尋輸入"},"__zh-mo":{"autoCompleteSearchInput":"自動完成搜尋輸入"},"__zh-sg":{"autoCompleteSearchInput":"自动完成搜索输入"},"__zh-tw":{"autoCompleteSearchInput":"自動完成搜尋輸入"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__27__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__57__;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[139,0]]]);
});